<template>
    <div class="ls-mask" @click="_click(1)" :style="{ zIndex: zIndex }">

        <div @click.stop :style="{ width: width }" class="ls-mask-inner">

            <div class="hd flex-b mb-20">
                <div class="tit ">
                    {{ title }}
                </div>
                <a class="close el-icon-close" @click="_click(0)"></a>
            </div>




            <div style="max-height: 70vh;overflow-y: auto;">

                <slot></slot>
            </div>

        </div>



    </div>
</template>

<script>
export default {
    props: {
        width: {
            default: '80vw'
        },
        title: {
            default: ''
        },
        zIndex: {
            default: 9999
        },
        mask_close: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
        _click(code) {
            if (code && !this.mask_close) {
                return;
            }

            this.$emit('close');


        }
    }
}
</script>

<style lang="scss" scoped>
@import "index.scss";
</style>